import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/automotive-updated/banner-auto.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={9} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Automotive App Development Company
              </h1>
              <span>Building Automotive Apps for Seamless Connectivity</span>
              <p style={{ marginTop: "10px" }}>
                We design and develop custom automotive apps for businesses and
                consumers, focusing on real-time connectivity, efficient fleet
                management, and seamless user experiences. Our automotive app
                development services integrate advanced telematics, predictive
                analytics, and automation to streamline vehicle operations,
                optimize logistics, and enhance mobility services. Partner with
                us to build high-performance apps tailored to your automotive
                business goals.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Request a Free Consultation Today
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
